/*
 * @Author: Gary
 * @Date: 2017-09-05 10:27:00
 * @Last Modified by: yuxiaojing
 * @Last Modified time: 2018-04-25 17:06:58
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';  // 引入babel兼容I

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import SvgIcon from 'vue-svg-icon/Icon'
import filters from "./common/js/filter/filter.js";
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import utc from 'dayjs/plugin/utc'
dayjs.extend(duration);
dayjs.extend(utc);
Vue.component('icon', SvgIcon);

// import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss';
import NProgress from 'nprogress' // 跳转页面进度条
import 'nprogress/nprogress.css'
import 'normalize.css/normalize.css'  // 重置样式E
import * as myFilter from '@/utils/filter' // 过滤器
import { getToken } from '@/utils/auth'
import axios from '@/utils/axios'
import MyComponents from '@/components' // 自定义组件

import 'font-awesome/css/font-awesome.css' // 需要引入font-awesome的图标
import '@/assets/iconfont/iconfont.css' //引入icon矢量库

import 'video.js/dist/video-js.css'

/* 自定义指令 */
import '././utils/btnPermissions.js'
Vue.use(ElementUI, { size: 'small' });
Vue.use(MyComponents);
Vue.prototype.axios = axios;
Vue.prototype.store = store;
Vue.prototype.dayjs = dayjs;

// 版本信息
Vue.prototype.VERSION = process.env.VERSION;
Vue.prototype.UPDATE_DATE = process.env.DATE;

//引入富文本框
import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)


// TODO 临时使用了cangfeng-safe的key
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '7933194a25460488dbd5403aa755d8a5',
  plugin: ['AMap.Autocomplete', 'AMap.Geolocation', 'AMap.AMapUI', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geocoder', 'AMap.CitySearch'],
  // plugin: ['Autocomplete', 'PlaceSearch', 'Scale', 'OverView', 'ToolBar', 'MapType', 'PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});
window._AMapSecurityConfig = {
  securityJsCode: 'aea1a573bafb74e9956b155af4ba4d37',
}

// 配置全局过滤器
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));

const whiteList = ['/login', '/downloadApp'];
// router.beforeEach((to, from, next) => {
//   NProgress.start();
//   // 已登录
//   if (getToken()) {
//     if (to.path === '/login') {
//       next({ path: '/' });
//       NProgress.done();
//     } else {
//       next();
//       NProgress.done();
//     }
//     // 未登录
//   } else {
//     if (whiteList.indexOf(to.path) !== -1) {
//       next();
//     } else {
//       next('/login');
//       NProgress.done();
//     }
//   }
// });

router.afterEach(() => {
  NProgress.done();
});

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js